import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-inline-block"
}

import {computed} from "vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import OperatorApplicationBuddyList from "~/operatorApplication/ts/service/OperatorApplicationBuddyList";
import {icon} from "~/ts/vuePlugins/IconPlugin";
import ClientIconsBeforeNameTargetTooltip
    from "~/operatorApplication/vue/dialogs/ClientIconsBeforeNameTargetTooltip.vue";
import BuddyListItemIcons from "~/operatorApplication/vue/dialogs/buddyList/item/BuddyListItemIcons.vue";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "ClientIconsBeforeName"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    userdata: {},
    light: { type: Boolean },
    onlyTogglers: { type: Boolean },
    maxOptionsIconsCount: {}
  },
  setup(__props: any) {

let props = __props;

function getIconClass(name: string) {
    return icon(name, props.light ? "fal" : "fas");
}

let flag = computed(() => {
    return OperatorAccountStore.flagsDictionary.value[props.userdata.flagId];
});

let optionsWithIcons = computed(() => OperatorApplicationBuddyList.getUserdataFieldOptionsWithIcons(props.userdata));


let isShowTargetReasons = computed(() => props.userdata.targetReasons.length && !props.onlyTogglers);
let isShowMuted = computed(() => props.userdata.isMuted);
let isShowFlag = computed(() => flag.value && !props.onlyTogglers);
let isShowOptionsWithIcons = computed(() => !props.onlyTogglers && optionsWithIcons.value.length > 0 && (!props.maxOptionsIconsCount || optionsWithIcons.value.length < props.maxOptionsIconsCount));
let isShowCrossOperatorsGroupChat = computed(() => props.userdata.type.isCrossOperatorsChat && !!OperatorAccountStore.crossOperatorChat.value[props.userdata.username]?.group);

let isShowSomething = computed(() => isShowCrossOperatorsGroupChat.value || isShowTargetReasons.value || isShowMuted.value || isShowFlag.value || isShowOptionsWithIcons.value);


return (_ctx: any,_cache: any) => {
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_unref(isShowSomething))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(isShowCrossOperatorsGroupChat))
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: _normalizeClass(`${getIconClass('user-group')} first-line-icon icon mr-2`)
            }, null, 2))
          : _createCommentVNode("", true),
        (_unref(isShowTargetReasons))
          ? _withDirectives((_openBlock(), _createElementBlock("i", {
              key: 1,
              class: _normalizeClass(`${getIconClass('crosshairs')} first-line-icon icon`)
            }, null, 2)), [
              [_directive_my_tooltip, {component: ClientIconsBeforeNameTargetTooltip, props: {userdata: __props.userdata}, delay: 500}]
            ])
          : _createCommentVNode("", true),
        (_unref(isShowMuted))
          ? (_openBlock(), _createElementBlock("i", {
              key: 2,
              class: _normalizeClass(`${getIconClass('volume-mute')} icon first-line-icon text-muted`)
            }, null, 2))
          : _createCommentVNode("", true),
        (_unref(isShowFlag))
          ? (_openBlock(), _createElementBlock("i", {
              key: 3,
              class: _normalizeClass(`${getIconClass('flag')} first-line-icon icon fas`),
              style: _normalizeStyle({color: `${_unref(flag).color} !important` })
            }, null, 6))
          : _createCommentVNode("", true),
        (_unref(isShowOptionsWithIcons))
          ? (_openBlock(), _createBlock(BuddyListItemIcons, {
              key: 4,
              "options-with-icons": _unref(optionsWithIcons),
              class: "text-nowrap"
            }, null, 8, ["options-with-icons"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})